import * as React from "react"
import { BiCheckCircle } from "react-icons/bi"
import { gql } from "@apollo/client"
import { ChevronDownIcon, ChevronUpIcon, InfoIcon } from "@chakra-ui/icons"
import {
  Alert,
  AlertIcon,
  Button,
  Collapse,
  Flex,
  HStack,
  Spinner,
  Stack,
  Text,
  useDisclosure,
} from "@chakra-ui/react"

import { MeDocument, useOrderPromoPackageMutation } from "lib/graphql"
import { useMe } from "lib/hooks/useMe"
import { useMutationHandler } from "lib/hooks/useMutationHandler"

import { ButtonGroup } from "./ButtonGroup"
import { Limiter } from "./Limiter"
import { Modal } from "./Modal"

const _ = gql`
  mutation OrderPromoPackage($id: String!) {
    orderPromoPackage(id: $id)
  }
`

export function ProfileBanner() {
  const { me, loading } = useMe()
  const modalProps = useDisclosure()
  const confirmationProps = useDisclosure()
  const handler = useMutationHandler()

  const [orderPromoPackage, { loading: orderLoading }] = useOrderPromoPackageMutation({
    refetchQueries: [{ query: MeDocument }],
  })

  const handleClick = () => {
    if (!me || me?.hasOrderedPromoPackage) return
    return handler(() => orderPromoPackage({ variables: { id: me.id } }), {
      onSuccess: (_, toast) => {
        toast({
          title: "Je promopakket is besteld",
          description: "Je ontvangt een bevestigingsmail met meer details",
        })
      },
    })
  }

  if (loading || me?.hasOrderedPromoPackage) return null

  return (
    <>
      <HStack
        top="0px"
        right={0}
        left={0}
        zIndex={100}
        bgColor="yellow.500"
        w="100%"
        py={2}
        cursor="pointer"
        onClick={modalProps.onOpen}
      >
        <Limiter>
          <HStack justify="center">
            <Text fontWeight="bold" fontSize="lg" color="black" aria-label="Promopakket bestellen" tabIndex={0} role="button">
              Klik hier om een Promopakket te bestellen!
            </Text>
            <InfoIcon color="black" />
            {orderLoading && <Spinner color="black" size="sm" />}
          </HStack>
        </Limiter>
      </HStack>
      <Modal {...modalProps} title="Bestel een promopakket!" size="xl">
        <Stack spacing={6}>
          <Stack>
            <Text>Wil je Kunstbende promoten op school? Ge-wel-dig!</Text>
            <Text>Bestel nu een pakket vol flyers, posters en stickers.</Text>
          </Stack>
          <ButtonGroup>
            <Button
              onClick={confirmationProps.onToggle}
              colorScheme="yellow"
              variant="link"
              leftIcon={confirmationProps.isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
            >
              Bestel promopakket
            </Button>
          </ButtonGroup>
          <Collapse in={confirmationProps.isOpen} animateOpacity>
            <Stack spacing={4}>
              <Flex>
                <Alert fontSize="sm">
                  <AlertIcon />
                  Door op deze button te klikken, maak je de bestelling definitief.
                </Alert>
              </Flex>
              <ButtonGroup>
                <Button onClick={confirmationProps.onClose} variant="outline">
                  Annuleren
                </Button>
                <Button
                  onClick={handleClick}
                  isLoading={orderLoading}
                  colorScheme="yellow"
                  leftIcon={<BiCheckCircle />}
                >
                  Bevestig bestelling
                </Button>
              </ButtonGroup>
            </Stack>
          </Collapse>
        </Stack>
      </Modal>
    </>
  )
}
